var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/ExplorerBody/ExplorerBody.tsx";
import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { equals } from 'ramda';
import { usePrevious } from '../../utils/usePrevious';
import { ExplorerPanel } from './ExplorerPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExplorerBody({
  activeItems,
  onSelectItem,
  loadingMap,
  onPanelContextMenu,
  onMove,
  panelWidth,
  canDrop,
  emptyPanelTitle,
  dndType
}) {
  const root = React.useRef(null);
  const prevActive = usePrevious(activeItems);
  React.useEffect(() => {
    const prev = prevActive === null || prevActive === void 0 ? void 0 : prevActive.map(item => item.key);
    const next = activeItems === null || activeItems === void 0 ? void 0 : activeItems.map(item => item.key);

    if (!equals(prev, next)) {
      var _root$current;

      const scrollTarget = activeItems.length * panelWidth;
      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.scrollLeft(scrollTarget);
    }
  }, [activeItems, panelWidth, prevActive]);
  return /*#__PURE__*/_jsx(Scrollbars, {
    ref: root // eslint-disable-next-line react/forbid-component-props
    ,
    style: {
      height: '100%',
      width: '100%',
      flexGrow: 1
    },
    children: /*#__PURE__*/_jsx("div", {
      style: {
        height: '100%',
        display: 'flex'
      },
      children: activeItems.map(item => /*#__PURE__*/_jsx(ExplorerPanel, {
        item: item,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onSelect: onSelectItem,
        loading: !!loadingMap[item.key],
        activeItems: activeItems,
        onPanelContextMenu: onPanelContextMenu,
        onMove: onMove,
        canDrop: canDrop,
        panelWidth: panelWidth,
        emptyPanelTitle: emptyPanelTitle,
        dndType: dndType
      }, item.key))
    })
  });
}
ExplorerBody.displayName = 'ExplorerBody';